import Uid from '../lib/uid'

const uid = new Uid(1)

const DEFAULT_FIELDS = {
  id: null,
  kind: 'default',
  content: '',
}

export default class PostSection {
  static text(text) {
    return new PostSection({ content: text })
  }
  // Create an image section
  static image({ src, width, height, caption = '' }) {
    const section = new PostSection({ kind: 'img' })
    Object.assign(section, {
      src,
      width,
      height,
      caption,
    })
    return section
  }
  // Create an oembed section
  static oembed({
    type,
    html,
    title,
    url,
    providerUrl,
    providerName,
    authorUrl,
    authorName,
    width,
    height,
  }) {
    const section = new PostSection({ kind: 'oembed' })
    Object.assign(section, {
      type,
      html,
      title,
      url,
      providerUrl,
      providerName,
      authorUrl,
      authorName,
      width,
      height,
    })
    return section
  }
  // Create an html content section
  static html({ html, content }) {
    return new PostSection({ content: html || content, kind: 'html' })
  }
  /*
   * Instance methods
   */

  constructor({ id, content = '', kind = 'default' } = {}) {
    Object.assign(this, DEFAULT_FIELDS)
    this.id = id || `${uid.getId()}-section`
    this.kind = kind
    this.content = content
  }

  toJson() {
    switch (this.kind) {
      case 'html':
        return {
          kind: 'html',
          html: this.content,
        }
      case 'img':
        return {
          kind: 'img',
          src: this.src,
          caption: this.caption,
          width: this.width,
          height: this.height,
        }
      case 'oembed':
        return {
          kind: 'oembed',
          type: this.type,
          html: this.html,
          title: this.title,
          url: this.url,
          providerUrl: this.providerUrl,
          providerName: this.providerName,
          authorUrl: this.authorUrl,
          authorName: this.authorName,
          width: this.width,
          height: this.height,
        }
      default:
        // it's a string
        return this.content
    }
  }
}
